module.exports = __webpack_public_path__ + "img/why-salem-online.fb426ea3.svg";